import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DocumentImage16Icon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M4.7 8.7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-.7a.7.7 0 1 0 0 1.3.7.7 0 0 0 0-1.3Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M4 .7a2 2 0 0 0-2 2v10.6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a.7.7 0 0 0-.2-.5L10.1 1a.7.7 0 0 0-.4-.2H4Zm8.7 9.1V6H9.3a.7.7 0 0 1-.6-.7V2H4a.7.7 0 0 0-.7.7v10.6a.7.7 0 0 0 .7.7h2.4l3.9-3.9a2 2 0 0 1 2.4-.3ZM8.3 14H12a.7.7 0 0 0 .7-.7v-1.7l-.6-.5a.7.7 0 0 0-.9 0l-3 2.9ZM12 4.7h-2v-2l2 2Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default DocumentImage16Icon;
